import { EntityGoal } from "../../entity/EntityGoal";

export class DtoGoalsPostRes extends EntityGoal {}
